export default {"src":"/_next/static/media/skills.b94d209f.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};